/**
 * The seat a running process waits on, as the band says it (SA-480, F3 of
 * the final review): the first open task's STAMPED seat, else the current
 * step's. The unopenable task may sit on a seat other than the step's live
 * one (an attention task on a fallback seat, a task opened before a live
 * re-seat), so the step's seat is only the fallback. SA-1079 lifted it out
 * so the Inbox record sidebar reads the same rule (SA-1036). Pure.
 */
import type { RecordProcessRead } from '@/types/process'

export function waitingSeatLabel(record: RecordProcessRead | null | undefined): string | null {
  return record?.open_tasks[0]?.seat_label ?? record?.current_step?.seat_label ?? null
}

/** SA-1077 (UX pass spec move 3): why the band's button is disabled. Null
 * when the band reads as before — the process is not running, no task is
 * open (an automation or AI step), or the viewer can open one. */
export type WaitingReason = 'not_in_seat' | 'cannot_work'

export function waitingReason(record: RecordProcessRead | null | undefined, canWorkTasks: boolean): WaitingReason | null {
  if (!record || record.status !== 'running' || record.open_tasks.length === 0) return null
  if (record.open_tasks.some((t) => t.can_open)) return null
  return canWorkTasks ? 'not_in_seat' : 'cannot_work'
}

/** The seat id `waitingSeatLabel` names, for the definition's `seats[id].roles`. */
export function waitingSeatId(record: RecordProcessRead | null | undefined): string | null {
  return record?.open_tasks[0]?.seat ?? record?.current_step?.seat ?? null
}
